import { useEffect, useState } from 'react'
import useAuthStore from '../stores/Auth'

export const useIsSecurityUser = () => {
  const [isSecurityUser, setIsSecurityUser] = useState(null)
  const state = useAuthStore((state) => state)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await state.isSecurityUser()
        setIsSecurityUser(result)
      } catch (error) {
        console.error('Error fetching isSecurityUser:', error)
        // Handle error if needed
      }
    }

    fetchData()
  }, [state])

  return isSecurityUser
}
